import React, { useEffect, useState } from 'react';
import loaderVideo from '../../assets/img/loaderV2.webm'
import { useBranding } from '../../context/brandingContext';

const Loader = () => {
    const branding = useBranding();
    const [failedCmsVideo, setFailedCmsVideo] = useState(false);
    const [readyVideo, setReadyVideo] = useState(null);
    const video = branding.loader && !failedCmsVideo ? branding.loader : loaderVideo;
    const mediaReady = branding.isReady && readyVideo === video;

    useEffect(() => {
        if (!branding.isReady || video === loaderVideo || readyVideo === video) return undefined;
        const timeout = setTimeout(() => setFailedCmsVideo(true), 5000);
        return () => clearTimeout(timeout);
    }, [branding.isReady, readyVideo, video]);

    return (
        <>
            <div
                style={{
                    position: "fixed",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                    backgroundColor: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 9999
                }}
            >
                {!mediaReady && (
                    <div role="status" aria-label="Cargando" className="spinner-grow text-muted" />
                )}
                {branding.isReady && <video
                    key={video}
                    src={video}
                    onLoadedData={() => setReadyVideo(video)}
                    onError={() => {
                        if (video !== loaderVideo) setFailedCmsVideo(true);
                    }}
                    autoPlay
                    muted
                    playsInline
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "375px",
                        height: "667px",
                        maxWidth: "375px",
                        maxHeight: "667px",
                        objectFit: "contain",
                        visibility: mediaReady ? "visible" : "hidden"
                    }}
                >
                </video>}
            </div>
        </>

    );
}
export default Loader;
